module.exports = __webpack_public_path__ + "img/tastings.e5964c28.jpg";